import React from 'react';
import SecurityContext from './Context';

export default (Component)=>(props)=>
    <SecurityContext.Consumer>{(securityManager)=><Component {...props} securityManager={securityManager} />}</SecurityContext.Consumer>
